module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table7E"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    staticClass: "editBox",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', {
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否有处罚情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.isPunishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "isPunishment", $$v)
      },
      expression: "params.isPunishment"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("具体情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "rows": 5,
      "type": "textarea",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.punishment),
      callback: function($$v) {
        _vm.$set(_vm.params, "punishment", $$v)
      },
      expression: "params.punishment"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "tipsLine"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n                注：\n                填写2023年和2024年内本单位受处罚的情况。须注明每次受处罚的时间、处罚原因、处罚结果、处罚执行单位、改进情况等问题。“处罚结果”项指被出版社行政部门给予的行政处罚、内部整顿、停业整顿或其他处罚。\n              ")])])])]), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("是否有处罚情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    class: _vm.historyJsonParams.isPunishment !== _vm.params.isPunishment ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.historyJsonParams.isPunishment),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "isPunishment", $$v)
      },
      expression: "historyJsonParams.isPunishment"
    }
  }, _vm._l((_vm.dicDats['C018']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }))], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("具体情况：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyJsonParams.punishment !== _vm.params.punishment ? 'highlight' : '',
    attrs: {
      "rows": 5,
      "type": "textarea",
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyJsonParams.punishment),
      callback: function($$v) {
        _vm.$set(_vm.historyJsonParams, "punishment", $$v)
      },
      expression: "historyJsonParams.punishment"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "tipsLine"
  }, [_c('div', {
    staticClass: "tips"
  }, [_vm._v("\n                注：\n                填写2021年和2022年内本单位受处罚的情况。须注明每次受处罚的时间、处罚原因、处罚结果、处罚执行单位、改进情况等问题。“处罚结果”项指被出版社行政部门给予的行政处罚、内部整顿、停业整顿或其他处罚。\n              ")])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.declare, "personnel", $$v)
      },
      expression: "declare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.declare.contact),
      callback: function($$v) {
        _vm.$set(_vm.declare, "contact", $$v)
      },
      expression: "declare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.updatedAt),
      callback: function($$v) {
        _vm.updatedAt = $$v
      },
      expression: "updatedAt"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value !== ''),
      expression: "value !== ''"
    }],
    staticClass: "editArea newEditArea",
    class: _vm.value !== '' ? 'newStyle' : ''
  }, [_c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报人：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.personnel !== _vm.declare.personnel ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.personnel),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "personnel", $$v)
      },
      expression: "historyDeclare.personnel"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("联系方式：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.contact !== _vm.declare.contact ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.contact),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "contact", $$v)
      },
      expression: "historyDeclare.contact"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "editBox"
  }, [_c('p', {
    staticClass: "edName"
  }, [_vm._v("申报时间：")]), _vm._v(" "), _c('div', {
    staticClass: "edInp"
  }, [_c('el-input', {
    class: _vm.historyDeclare.updatedAt !== _vm.updatedAt ? 'highlight' : '',
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.historyDeclare.updatedAt),
      callback: function($$v) {
        _vm.$set(_vm.historyDeclare, "updatedAt", $$v)
      },
      expression: "historyDeclare.updatedAt"
    }
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', [_vm._v("表 1-7：受处罚情况表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "headBar"
  }, [_c('span', [_vm._v("申报人信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66e6246b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table7.vue
// module id = 1763
// module chunks = 1